export default __webpack_public_path__ + "static/media/filter_video.12ff27f6.svg";